import { FunctionComponent, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Anchor, Question } from '../../App.styles';
import NotificationBox, { Text } from '../../components/NotificationBox';
import { ResultInfo } from '../../components/Result/Result.styles';
import { GlobalContext, updateGetNotified } from '../../contexts';
import { useMetrics } from '../../hooks';
import { AMZ_BLACK } from '../../styles/colors';
import { metricEvents, MetricProperty, TestId } from '../../utils';
import { createBrandModelPair } from '../../utils/brandModelPair';
import {
  ActionButton,
  GetNotifiedContainer,
  NotifiedDescription,
  NotifiedTitle,
  PrivacyNoticeDisclaimer,
} from './NotCompatibleAmazon.styles';

interface GetNotifiedProps {
  brand: string;
  model: string;
}

const GetNotified: FunctionComponent<GetNotifiedProps> = ({ brand, model }) => {
  const { state: global, dispatch } = useContext(GlobalContext);
  const { track } = useMetrics();
  const { t } = useTranslation('common');

  const { amazonId, getNotified } = global;

  const brandModelPair = createBrandModelPair(brand, model);
  const optedIn = getNotified.has(brandModelPair);

  return (
    <GetNotifiedContainer
      data-testid={TestId.GetNotified}
      className="get-notified border"
    >
      <NotifiedTitle as={Question}>
        {t('results.notCompatible.getNotified.title')}
      </NotifiedTitle>

      <NotifiedDescription as={ResultInfo}>
        {t('results.notCompatible.getNotified.description')}
      </NotifiedDescription>

      {!amazonId && (
        <NotificationBox variant="info">
          <Text color={AMZ_BLACK}>
            {t('results.notCompatible.getNotified.signInInfo')}
          </Text>
        </NotificationBox>
      )}

      {amazonId && (
        <>
          {optedIn && (
            <NotificationBox variant="success">
              <Text>{t('results.notCompatible.getNotified.allSet')}</Text>
            </NotificationBox>
          )}

          <ActionButton
            disabled={optedIn}
            className="w-100 rounded-pill"
            type="button"
            onClick={() => {
              dispatch(
                updateGetNotified({
                  getNotified: {
                    model,
                    brand,
                  },
                })
              );
              track(metricEvents.getNotifiedOptedIn, {
                [MetricProperty.getNotifiedOptedIn]: true,
                brand,
                model,
                amazonId,
              });
            }}
          >
            {t('results.notCompatible.getNotified.optInBtn')}
          </ActionButton>
        </>
      )}

      <PrivacyNoticeDisclaimer>
        <Trans i18nKey="common:results.notCompatible.getNotified.privacyNotice">
          notice{' '}
          <Anchor
            noUnderline
            href="/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ"
          >
            link
          </Anchor>
        </Trans>
      </PrivacyNoticeDisclaimer>
    </GetNotifiedContainer>
  );
};

export default GetNotified;
